import React from 'react';
import './ProductGrid.css';
import ProductCard from './ProductCard';
import { products } from '../../data/products';

const ProductGrid = ({ setRoute }) => {
  return (
    <section id="products" className="section">
      <div className="container">
        <h2>Our Products</h2>
        <p className="section-subtitle">
          Premium Kajun seasonings handcrafted for bold, authentic flavor
        </p>
        
        <div className="product-grid">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} setRoute={setRoute} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductGrid;
